/* src/app/forms/json-component/app-json-config/app-json-config.component.scss */
.parameter-block {
  margin-bottom: 20px;
}
.parameter-block fieldset {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 15px;
}
.parameter-block legend {
  font-weight: bold;
  padding: 0 10px;
  font-size: 24px;
  color: #3f51b5;
}
.table-section {
  font-size: 20px;
}
.parameter-section {
  font-size: 20px;
}
.service-config {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  margin-left: 10px;
}
.service-config mat-icon {
  font-size: 20px;
}
.service-config span {
  font-size: 16px;
  color: #555;
  white-space: nowrap;
}
.parameter-section,
.table-section,
.json-preview {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.parameter-section h3,
.table-section h3,
.json-preview h3 {
  font-size: 1.2em;
  margin-bottom: 10px;
}
.table-header {
  margin-left: 5px;
}
.input-group {
  margin-left: 5px;
}
.parameter-row,
.table-header,
.column-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
}
.btn-service {
  width: 53px;
}
.input-group {
  margin-right: 15px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
}
.input-group label {
  font-weight: bold;
  margin-bottom: 5px;
}
.input-group input,
.input-group select {
  padding: 8px;
  font-size: 1em;
  border-radius: 4px;
  border: 1px solid #ddd;
}
button {
  padding: 8px 15px;
  margin-top: 10px;
  border: none;
  border-radius: 4px;
  background-color: #4CAF50;
  color: white;
  cursor: pointer;
}
.marginLeftIcon {
  margin-left: -9px;
}
.formula {
  margin-right: 5px;
}
button:hover {
  background-color: #45a049;
}
.remove-btn {
  background-color: #f44336;
  margin-left: 10px;
}
.remove-btn:hover {
  background-color: #e53935;
}
.add-btn,
.add-column-btn,
.add-table-btn {
  background-color: #008CBA;
  margin-right: 7px;
}
.add-btn:hover,
.add-column-btn:hover,
.add-table-btn:hover {
  background-color: #007bb5;
}
.columns-section,
.child-tables {
  margin-top: 20px;
}
.column-row {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
}
.column-row .input-group {
  margin-right: 20px;
}
.json-preview pre {
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 20px;
}
.custom-dialog-container {
  margin: 20px !important;
}
.json-preview {
  margin-top: 20px;
}
.json-editor-field {
  width: 100%;
}
.json-editor-field textarea {
  font-family: monospace;
  font-size: 13px;
  min-height: 300px;
  white-space: pre;
}
.json-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
.json-error {
  margin-top: 10px;
  color: red;
  font-weight: 500;
}
.json-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  justify-content: flex-end;
}
.input-group input {
  font-family: monospace;
}
/*# sourceMappingURL=app-json-config.component.css.map */
